var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPurpleTick = function SvgPurpleTick(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#6815E4",
    fillRule: "evenodd",
    d: "M23.5 45C11.626 45 2 35.374 2 23.5S11.626 2 23.5 2 45 11.626 45 23.5 35.374 45 23.5 45m9.536-26.22a2 2 0 1 0-3.072-2.56l-8.598 10.317-4.452-4.451a2 2 0 0 0-2.828 2.828l6 6a2 2 0 0 0 2.95-.134z",
    clipRule: "evenodd"
  })));
};
export default SvgPurpleTick;